import * as React from 'react';

function OwSpecialsIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width="100%" height="100%" viewBox="0 0 19 19" fill="none" {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.81 2.594h1.413l2 4.27H6.803l2.009-4.27zm-3.616 4.27l2.009-4.27h-1.96a1.84 1.84 0 00-1.45.775L1.676 6.282l-.003.005a1.846 1.846 0 00-.273.578h3.794v-.002zM1.64 8.308h3.524l2.238 7.129-5.633-6.955a2.318 2.318 0 01-.13-.171v-.003zm5.049 0h5.648L9.622 16.99a2.338 2.338 0 01-.205.003L6.69 8.31h-.001zm7.173 0l-2.21 7.061 5.58-6.888c.045-.055.089-.113.129-.172h-3.5zM17.6 6.863a1.846 1.846 0 00-.272-.577l-.003-.005-2.117-2.91a1.825 1.825 0 00-1.45-.776v-.001h-1.927l2 4.27H17.6z"
				fill="currentColor"
			/>
		</svg>
	);
}

export default OwSpecialsIcon;
